import {Button, RadioGroup, RadioGroupItem} from "../components";
import {AnimatePresence, motion} from "framer-motion";
import React, {useState} from "react";
import {BenefitCards} from "./BenefitCards";
import {Emoji} from "./Emoji";
import {spring} from "../lib/utils";
import * as Icon from "../icons";
import * as Dialog from "@radix-ui/react-dialog";
import {useTranslation} from "react-i18next";

const ModalDesktop = ({
                        open,
                        onClose,
                        productJson,
                      }: {
  open: any;
  onClose: any;
  productJson: RootObject; // replace RootObject with the actual type
}) => {
  const {t} = useTranslation();
  const [people, setPeople] = useState(2);

  return (
    <Dialog.Root open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <Dialog.Portal forceMount>
        <AnimatePresence>
          {open && (
            <Dialog.Overlay
              key="overlay"
              className="bg-black/80 fixed inset-0 z-50"
              asChild
            >
              <motion.div
                transition={{duration: 0.1, ease: "linear"}}
                initial={{opacity: 0}}
                animate={{opacity: 1}}
                exit={{opacity: 0}}
              />
            </Dialog.Overlay>
          )}
          {open && (
            <Dialog.Content
              key="content"
              asChild>
              <div
                className="fixed flex flex-col gap-8 top-[52%] left-[50%] min-h-[700px] max-h-[85vh] w-[90vw] translate-x-[-50%]
                            translate-y-[-50%] min-w-[950px] max-w-[1000px] z-50 !pointer-events-none"
              >
                <Emoji />
                <motion.div
                  className="rounded-3xl bg-white focus:outline-none flex overflow-hidden pointer-events-auto"
                  transition={{
                    ...spring.snappy,
                    opacity: {duration: 0.1, ease: "linear"},
                  }}
                  initial={{scale: 0, opacity: 0}}
                  animate={{scale: 1, opacity: 1}}
                  exit={{scale: 0.95, opacity: 0}}
                >
                  <video
                    src={"/" + window.demovideoUrl}
                    className="flex-[2] max-w-[40%] aspect-[2/3] object-cover"
                    playsInline
                    autoPlay
                    muted
                    loop
                  />
                  <div className="flex-[3] p-8 pl-10 pt-14 flex flex-col gap-2">
                    <Dialog.Title asChild>
                      <h1 className="text-6xl font-medium mb-3">
                        {t("recipe_details.cta.popup.title")}
                      </h1>
                    </Dialog.Title>
                    <Dialog.Close
                      className="p-4 absolute right-5 top-5 rounded-xl opacity-50
                        hover:opacity-100 hover:bg-slate-500/5
                      "
                    >
                      <Icon.Close />
                    </Dialog.Close>
                    <div className="mt-auto">
                      <BenefitCards />
                    </div>
                    <div className="border rounded-lg p-4 flex items-center justify-center gap-3">
                      <Icon.Smile />
                      <span>{t("recipe_details.cta.popup.question")}</span>
                    </div>
                    <div className="flex gap-2">
                      <RadioGroup
                        className="flex-[3]"
                        defaultValue={people.toString()}
                        onValueChange={(val) => setPeople(parseInt(val))}
                      >
                        <RadioGroupItem value="2" />
                        <RadioGroupItem value="4" />
                      </RadioGroup>
                      <Button className="flex-[5]" asChild>
                        <a
                          href={`/collections/boxes?productId=${productJson.id}&people=${people}`}
                        >
                          {t("recipe_details.cta.popup.button")}
                        </a>
                      </Button>
                    </div>
                  </div>
                </motion.div>
                <motion.div
                  transition={{
                    ...spring.snappy,
                    opacity: {duration: 0.1, ease: "linear"},
                  }}
                  initial={{scale: 0.95, y: -20, opacity: 0}}
                  animate={{scale: 1, y: 0, opacity: 1}}
                  exit={{scale: 0.95, y: -20, opacity: 0}}
                  className="text-white flex flex-col items-center text-center mx-auto"
                >
                  <h2 className="text-white font-medium">
                    {t("recipe_details.cta.popup.hint_title", {count: 40})}
                  </h2>
                  <p className="max-w-sm text-gray-400">
                    {t("recipe_details.cta.popup.hint_text")}
                  </p>
                </motion.div>
              </div>
            </Dialog.Content>
          )}
        </AnimatePresence>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export {ModalDesktop};
